// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-Q":"Q_load-shedding-Q__NQMzR"};